import { render } from "./CreatorListSidebar.vue?vue&type=template&id=c071f324"
import script from "./CreatorListSidebar.vue?vue&type=script&lang=js"
export * from "./CreatorListSidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__